import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PDF from './PDF';
import Iframe from 'react-iframe'
import { Document, Page, pdfjs} from 'react-pdf';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import withSizes from 'react-sizes';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ChatbotReEnterData from './ChatbotReEnterData'
import * as actions from '../../store/actions/index';

import UploadDocsSingleFile from '../../containers/Onboarding/UploadDocsSingleFile'


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = theme => ({
    body:{
        backgroundColor: 'grey',
    },
    sigPad:{
        backgroundColor: 'white',
        width: '100%',
        height: '100%',
    },
    container: {
        // margin: theme.spacing.unit * 5,
        //width: '50%',
        //minwidth: '30%',
        width: 400,
        height: 250,
        maxHeight: 300,
        minHeight: 200,
        //top: '10%',
        // left: '10%',
    },
    sigContainer: {
        maxWidth: '100%',
        minwidth: '30%',
        height: '80%',
        alignItems:'left',
        backgroundColor: '#fff',
    },
    button: {
        //width: '100%',
    },
    sigImage: {
        backgroundSize: '200px 50px',
        width: '200px',
        height: '200px',
        backgroundColor: 'white',
    },
    pdfMargin:{
        // paddingRight: 10
    },
    containern:{
        width:'50%',
        '@media (max-width: 576px)': {
            width: '100%'
          }
    }
});

class ReadPDFResponse extends Component{

    state = {
        trimmedDataURL: null,
        userType:'',
        reEnterData: false,
        uniqueId: localStorage.getItem('token'),
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth,
        widthpercent:'50%'
    }

    switchReEnterData= () => {
        if(this.props.claimantUniqueId == this.state.uniqueId){
            this.setState({
                userType:'claimant'
            })
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            this.setState({
                userType:'respondent'
            })
        }

        if (this.state.userType == 'claimant'){
            localStorage.removeItem('token');
            localStorage.removeItem('tokenExpirationDate');
            localStorage.removeItem('caseId');
            window.open('https://www.hkarbsoc.org.hk/odr','_blank');
        }
        else if (this.state.userType == 'respondent'){
            this.props.changeResponseToReEnter(this.props.caseId)
        }
    }

    componentDidMount(){
        console.log('this.props.isMobile')
        console.log(this.props.isMobile)
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        if(this.props.claimantUniqueId == this.state.uniqueId){
            this.setState({
                userType:'claimant'
            })
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            this.setState({
                userType:'respondent'
            })
        }
        
    }

    handleResize = () => {
        this.setState({
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth,
        });
        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 480){
            this.setState({
                widthpercent: '100%'
            })
      }
    }

    render(){
        const { classes } = this.props;
        let fileURL = '';
        fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`;
        let fileMobile = "https://drive.google.com/viewerng/viewer?embedded=true&url="+fileURL+"#toolbar=1&scrollbar=1"
        console.log('fileMobile')
        console.log(fileMobile)
        return(
            <div className={classes.divStyle} style={{ height:'100vh', marginBottom: this.props.isMobile ? '60px':'10px' }}>
                { this.props.isMobile && <div style={{textAlign:'center'}}>{this.context.t("Click to open PDF/Word")}</div> }
                { this.props.isMobile &&
                    <div style={{textAlign:'center', padding:'5px'}}>
                        <a style={{textAlign:'center'}} target="_blank" href={fileURL}>
                        {this.context.t("Download PDF")}
                        </a>
                    </div>
                }
                <div>
                <PDF
                    isDesktop={this.props.isMobile}
                    file={fileURL}
                />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    caseId: state.caseInfo.caseId,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    caseData: state.caseInfo.caseData,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return { 
      onLogout: () => dispatch(actions.logout()),
      getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
      changeResponseToReEnter: (caseId) => dispatch(actions.changeResponseToReEnter(caseId)),
    }
  }

  const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

ReadPDFResponse.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withSizes(mapSizesToProps)(withRouter(ReadPDFResponse))));